import { render, staticRenderFns } from "./CertificateInfoNotification.vue?vue&type=template&id=778bcb18&"
import script from "./CertificateInfoNotification.vue?vue&type=script&lang=js&"
export * from "./CertificateInfoNotification.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports